import { Navigate, Outlet } from 'react-router-dom';
import { getIsLoggedIn, logout } from 'src/shared/redux-state/src';
import { useAppSelector, useAppDispatch, store } from '../services/store';
import { AppRoutes } from '../navigation/routes';

const AuthGuard = () => {

    const dispatch = useAppDispatch();

    const isLoggedIn = useAppSelector(getIsLoggedIn);

    const cannotAccess = () => {
        (async ()=>{
            await dispatch(logout({ reduxStore: store }));
        })()
        return <Navigate to={AppRoutes.VERIFY_EMAIL} />
    }

    return (
        isLoggedIn ? <Outlet /> : <>{cannotAccess()}</>
    )
}

export default AuthGuard;